module.exports = __webpack_public_path__ + "img/about-8.f2b1cfa5.png";